import { styled } from "styled-components";
import Moment from "react-moment";
import posts from "../posts.json";
import { ButtonWrap } from "./ShortBlog";
import { useNavigate } from "react-router-dom";
import Placeholder from "../assets/images/placeholder-big.jpg"
import AuthorBox from "./Author";

function LatestBlog() {
  const navigate = useNavigate();
  const latest = posts.length > 0 ? posts[0] : null;
  const showBlog = () => {
    navigate(`/blogs/${latest.category}/${latest.alias}`);
  };
  const thumbnail = latest.fields.images && latest.fields.images.banner ?  `data:image/jpg;base64, ${latest.fields.images.banner}`:Placeholder;
  const photo = latest.fields.images && latest.fields.images.author ? `data:image/jpg;base64, ${latest.fields.images.author}`:"";
  return (
    <LatestWrapper onClick={showBlog}>
      {latest && (
        <>
          <Thumbnail>
            <img src={thumbnail} alt="" />
          </Thumbnail>
          <Inner>
            {latest.category && <Category>{latest.category}</Category>}
            <Title>{latest.title}</Title>
            <Desc>{latest.description}</Desc>
            <PDate>
              <Moment format="MMMM D, YYYY">{latest.modifiedWhen}</Moment>
            </PDate>
            <ButtonWrap>
            <AuthorBox name={latest.createdBy} photo={photo} />
              {/* <Link to={`/blogs/${latest.category}/${latest.alias}`}>
                <Button>Read more</Button>
              </Link> */}
            </ButtonWrap>
          </Inner>
        </>
      )}
    </LatestWrapper>
  );
}

export default LatestBlog;

const LatestWrapper = styled.section`
  display: flex;
  min-height: 400px;
  background: #f4f4f4;
  border-radius: 4px;
  overflow: hidden;
  cursor:pointer;
  @media (max-width: 864px) {
    display: block;
  }
`;

const Category = styled.p`
  font-size: 13px;
  color: #aaa;
`;

const Inner = styled.section`
  padding: 20px;
`;
const PDate = styled.p`
  font-size: 13px;
  padding-top: 20px;
  color: #aaa;
`;
const Desc = styled.p`
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-bottom: 30px;
`;

const Title = styled.h3`
  font-size: 22px;
  margin-bottom: 30px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const Thumbnail = styled.section`
  margin-right: 10px;
  min-width: 66.5%;
  overflow: hidden;
  max-width: 700px;
  position: relative;
  img {
    height: 400px;
    display: block;
    position: absolute;
    top:0;
    right: 0;
  }
  @media (max-width: 864px) {
    max-width: auto;
    min-width: 100%;
    img {
      position: static;
      height: auto;
      width: 100%;
    }
  }
`;
